import React from 'react';
import classNames from 'classnames';

import { truncateString } from '@eb/string-utils';

import { EVENT_TITLE_MAX_LENGTH } from './constants';

const FormattedEventName = ({ eventName, isConsumer }) => {
    const clampedClassNames = classNames(
        'eds-event-card__formatted-name--is-clamped',
        {
            'eds-event-card__formatted-name--is-clamped-three eds-text-weight--heavy': isConsumer,
        },
    );

    return (
        <div data-spec="event-card__formatted-name">
            <div className="eds-is-hidden-accessible">{eventName}</div>

            <div
                className={clampedClassNames}
                aria-hidden="true"
                role="presentation"
                data-spec="event-card__formatted-name--content"
            >
                {truncateString(eventName, EVENT_TITLE_MAX_LENGTH)}
            </div>
        </div>
    );
};

export default FormattedEventName;
